export var ThreadStatus;
(function (ThreadStatus) {
    ThreadStatus["READY"] = "ready";
    ThreadStatus["PROCESSING"] = "processing";
    ThreadStatus["COMPLETED"] = "completed";
})(ThreadStatus || (ThreadStatus = {}));
//# sourceMappingURL=Thread.js.map